import {useState, useRef, useEffect} from 'react';
import {createPortal} from 'react-dom';
import {observer} from 'mobx-react';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';
import {ActionLink} from 'shared/components';

const PageLink = observer(({text, action}) => {
  return (
    <ActionLink className='py1 px2 regular jumbo' onClick={action}>
      <FormattedMessage id={text}/>
    </ActionLink>
  );
});

const SubnavOverflowTab = observer(({links = [], isActive}) => {
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const [showDropdown, setShowDropdown] = useState(false);

  const updateDropdownPosition = () => {
    if (buttonRef.current && dropdownRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: `${rect.bottom + window.scrollY + 16}px`,
        left: `${rect.left + window.scrollX}px`
      });
    }
  };

  const isClickOutside = e => {
    if (!buttonRef.current) return;

    return !buttonRef.current.contains(e.target) && dropdownRef.current && !dropdownRef.current.contains(e.target);
  };

  const handleClickOutside = e => {
    if (isClickOutside(e)) setShowDropdown(false);
  };

  useEffect(() => {
    window.addEventListener('resize', updateDropdownPosition);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('resize', updateDropdownPosition);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    updateDropdownPosition();
  }, [showDropdown]);

  if (_.isEmpty(links)) return null;

  links = links
    .map(link => ({
    order: link.order,
    key: link.text,
    Component: () => <PageLink text={link.text} action={link.action}/>
  }));

  const onClick = (e) => {
    e.stopPropagation();
    setShowDropdown(!showDropdown);
  };

  return (
    <a className={`overflow ${isActive ? 'active' : ''}`}>
      <div onClick={e => onClick(e)} className='relative'>
        <div ref={buttonRef} className='jumbo flex align-items-middle clickable user-select-none'>
          <FormattedMessage id='components.subnav.More'/>
          <i className={`material-icons waterloo overflow-chevron ${showDropdown ? 'expanded' : ''}`}>{'chevron_right'}</i>
        </div>
        {showDropdown && createPortal(
          <ul
          className='dropdown-menu block'
          style={{ position: 'absolute', top: dropdownPosition.top, left: dropdownPosition.left, zIndex: 1000 }}
          ref={dropdownRef}
          >
            {_.orderBy(links, 'order').map(l => <li key={l.key}><l.Component/></li>)}
          </ul>,
          document.body
        )}
      </div>
    </a>
  );
});

export default SubnavOverflowTab;
